// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FormattedException
 */
export interface FormattedException {
  /**
   *
   */
  title: string;
  /**
   *
   */
  traceback: string;
  /**
   *
   */
  errorType: FormattedExceptionErrorTypeEnum;
  /**
   *
   */
  description?: string | null;
}

/**
 * @export
 */
export const FormattedExceptionErrorTypeEnum = {
  User: "user",
  Internal: "internal",
} as const;
export type FormattedExceptionErrorTypeEnum =
  (typeof FormattedExceptionErrorTypeEnum)[keyof typeof FormattedExceptionErrorTypeEnum];

/**
 * Check if a given object implements the FormattedException interface.
 */
export function instanceOfFormattedException(value: object): value is FormattedException {
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("traceback" in value) || value["traceback"] === undefined) return false;
  if (
    (!("errorType" in (value as Record<string, any>)) &&
      !("error_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["errorType"] === undefined &&
      (value as Record<string, any>)["error_type"] === undefined)
  )
    return false;
  return true;
}

export function FormattedExceptionFromJSON(json: any): FormattedException {
  return FormattedExceptionFromJSONTyped(json, false);
}

export function FormattedExceptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FormattedException {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"],
    traceback: json["traceback"],
    errorType: json["error_type"],
    description:
      json["description"] === undefined
        ? undefined
        : json["description"] === null
        ? null
        : json["description"],
  };
}

export function FormattedExceptionToJSON(json: any): FormattedException {
  return FormattedExceptionToJSONTyped(json, false);
}

export function FormattedExceptionToJSONTyped(
  value?: FormattedException | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    title: value["title"],
    traceback: value["traceback"],
    error_type: value["errorType"],
    description: value["description"],
  };
}
